<template>
  <div class="container">
    <div class="head-dec"></div>
    <div class="banner">
      <div class="info-search-panel">
        <div class="module-title">信息检索</div>
        <div class="conditions" v-if="!$isPhone">
          <div
            class="condition"
            :class="{ active: curCondition === item.key }"
            v-for="(item, index) in conditions"
            :key="'con' + index"
            @click="toggleCondition(item.key)"
          >
            {{ item.name }}
          </div>
        </div>
        <el-input placeholder="请输入内容" v-model="searchValue" style="width: 807px; margin-top: 30px;background-color: rgba(245, 242, 235, 1);border-radius: 4px;">
          <template slot="prepend" v-if="!$isPhone"><i class="el-icon-search"></i></template>
          <template slot="append" v-if="!$isPhone">
            <div class="custom-btn" style="background-color: #7c1823" @click="searchByInput">搜索</div>
            <!-- <div class="custom-btn" style="background-color: #9e8871; margin-left: 8px" @click="$refs.advancedSearch.open()">高级搜索</div> -->
          </template>
        </el-input>
        <div class="pop-search" v-if="!$isPhone">
          <div class="word">热门搜索:</div>
          <div class="word v" v-for="(item, index) of searchKeywords" :key='index' @click="pickWord(item)">{{ item }}</div>
        </div>
        <div class="library-des">
          <p>
            西宁市图书馆打造的《西图古籍云鉴》，是西宁市图书馆古籍保护计划的重要成果，也是面向公众的综合性古籍数字资源发布共享平台。
          </p>
          <p>
            平台秉持“边建设、边服务”原则，目前已在线发布古籍资源200多册，为用户提供古籍资源的便捷获取渠道。在功能设计上，平台涵盖全文检索、热门资源推荐、图文对照等核心功能，可充分满足用户对古籍资源的查询、浏览与研究等基本需求，助力古籍文化的数字化传承与共享。
          </p>
        </div>
      </div>
    </div>
    <div class="module-title">知识统计</div>
    <div class="knowledge-statistics">
      <rank/>
      <div class="part">
        <resourceHeat></resourceHeat>
      </div>
      <div class="part">
        <div class="part-title">&diams;<span class="inline-title">知识统计</span></div>
        <d2-pie />
      </div>
      <div class="part">
        <div class="part-title">&diams;<span class="inline-title">资源词云</span></div>
        <word-cloud />
      </div>
    </div>
  </div>
</template>

<script>
import D2Pie from './D2-pie'
import resourceHeat from './resourceHeat'
import rank from './rank'
import wordCloud from './word-cloud.vue'
import searchApi from '@/api/search.js'

export default {
  name: 'index',
  data () {
    return {
      searchValue: '',
      conditions: [
        {
          name: '经部',
          key: '经部'
        },
        {
          name: '史部',
          key: '史部'
        },
        {
          name: '子部',
          key: '子部'
        },
        {
          name: '集部',
          key: '集部'
        }
      ],
      curCondition: '全部',
      tcmGenreClassification: '',
      searchKeywords: []
    }
  },
  components: {
    D2Pie,
    resourceHeat,
    rank,
    wordCloud
  },
  methods: {
    searchByInput () {
      if (this.searchValue === '') return this.$message.warning('请输入搜索内容!')
      let url = window.location.origin + window.location.pathname
      this.$bus.$emit('openLogin', {
        url: `${url}#/literature?input=${this.searchValue}&category=${this.curCondition}`
      })
    },
    setTcm (val) {
      this.tcmGenreClassification = val
    },
    toggleCondition (key) {
      this.curCondition = this.curCondition === key ? '全部' : key
    },
    getSearchKeywords () {
      searchApi.selectSearchKeywords({
        pageSize: 5
      }).then(res => {
        // console.log(res)
        res.rows.forEach(item => {
          this.searchKeywords.push(item.keyword);
        });
      })
    },
    pickWord (word) {
      this.searchValue = word
      this.searchByInput()
    }
  },
  mounted () {
    this.getSearchKeywords();
  }
}
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
@import "./home-web.less";
// @media screen and (max-width: 768px) {
//   @import "./home-mobile.less";
// }
</style>
